import { render } from "./OnTheJobDocumentList.vue?vue&type=template&id=ee958ac2"
import script from "./OnTheJobDocumentList.vue?vue&type=script&lang=ts"
export * from "./OnTheJobDocumentList.vue?vue&type=script&lang=ts"
script.render = render

export default script